// Build props for CurriculumLibraryTreeView (E179)
export const buildLibraryTreeViewProps = (
    onTreeNodeSelect: (node: any) => void,
    selectedTopics: any[],
    expandedNodes: Set<string>,
    setExpandedNodes: (nodes: Set<string>) => void,
    curriculumData: any,
    studentCurriculumData: any,
    selectedProvider: string,
    backendLessons: any[],
    selectedStudentPassFailThreshold: number | null,
    onLoadNodeChildren: (nodeId: string, nodeType: 'year' | 'topic') => void,
    loadedNodeIds: Set<string>,
    loadingNodeIds: Set<string>,
    showHint?: boolean,
    assumeTopicsLoaded?: boolean,
    selectedStudentFirstName?: string,
    /** Must match E180’s e180_StudentId when present, or client “already in plan” checks can use wrong student. */
    selectedStudentIdForStudentCurriculumCheck?: string | null,
    onOpenInstructionalUnit?: (unit: any) => void
) => {
    return {
        onNodeSelect: onTreeNodeSelect,
        selectedTopics,
        expandedNodes,
        onExpandedNodesChange: setExpandedNodes,
        curriculumData,
        studentCurriculumData, // For checking if topics are already in student curriculum
        isSelectingFromProvider: true,
        units: backendLessons,
        passFailThreshold: selectedStudentPassFailThreshold,
        onLoadNodeChildren,
        curriculumProviderKey: selectedProvider,
        loadedNodeIds,
        loadingNodeIds,
        showHint: showHint ?? false,
        assumeTopicsLoaded: assumeTopicsLoaded ?? false,
        selectedStudentFirstName: selectedStudentFirstName ?? '',
        selectedStudentIdForStudentCurriculumCheck: selectedStudentIdForStudentCurriculumCheck ?? null,
        onOpenInstructionalUnit
    };
};

// Build props for StudentCurriculumTreeView (E180)
export const buildStudentCurriculumTreeViewProps = (
    onTreeNodeSelect: (node: any) => void,
    selectedTopics: any[],
    expandedNodes: Set<string>,
    setExpandedNodes: (nodes: Set<string>) => void,
    studentCurriculumData: any,
    backendLessons: any[],
    selectedStudentPassFailThreshold: number | null,
    onLoadNodeChildren: (nodeId: string, nodeType: 'year' | 'topic') => void,
    loadedNodeIds: Set<string>,
    loadingNodeIds: Set<string>,
    studentId?: string | null,
    selectedStudentFirstName?: string,
    onOpenInstructionalUnit?: (unit: any) => void,
    setStudentCurriculumData?: (data: any) => void
) => {
    return {
        onNodeSelect: onTreeNodeSelect,
        selectedTopics,
        expandedNodes,
        onExpandedNodesChange: setExpandedNodes,
        studentCurriculumData,
        isStudentCurriculumSelecting: true,
        units: backendLessons,
        passFailThreshold: selectedStudentPassFailThreshold,
        onLoadNodeChildren,
        loadedNodeIds,
        loadingNodeIds,
        studentId,
        selectedStudentFirstName,
        onOpenInstructionalUnit,
        setStudentCurriculumData
    };
};
